<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon
        data-cy="app-bar-nav-icon"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      {{ $t("Dashboard") }}
      <v-spacer></v-spacer>
      <selectLang></selectLang>
      <v-btn outlined @click="logout" class="text-none">{{
        $t("Sign out")
      }}</v-btn>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" color="primary" dark>
      <v-list nav>
        <v-list-item class="title" style="margin-bottom: 0px">{{
          $store.state.auth.user ? $store.state.auth.user.name : ""
        }}</v-list-item>
        <v-list-item
          v-for="item in itemNavigation"
          :key="item.title"
          link
          exact
          :to="{ name: item.name }"
          :disabled="
            $store.state.auth.user
              ? !$store.state.auth.user.reseller_active &&
                item.name !== 'Support' &&
                item.name !== 'Home'
              : false
          "
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-treeview
          activatable
          open-on-click
          :items="itemsDoc"
          item-key="route"
          @update:active="changeDoc"
        >
          <template slot="label" slot-scope="props">
            <span style="color: white; text-decoration: none !important">{{
              props.item.name
            }}</span>
          </template>
        </v-treeview>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>
    <snackbar></snackbar>
  </v-app>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import Snackbar from "@/components/Snackbar";
import selectLang from "../components/SelectLang";

export default {
  name: "Home",
  components: { Snackbar, selectLang },
  mixins: [snackbar],
  data() {
    return {
      drawer: true,
    };
  },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => this.$router.push({ name: "Welcome" }));
    },
    changeDoc(event) {
      if (event.length > 0) {
        const routeName = event[0];
        if (this.$route.name != routeName) {
          this.$router.push({ name: routeName });
        }
      }
    },
  },
  created() {
    this.$store.dispatch("fetchAll");
  },
  computed: {
    itemNavigation() {
      let result = [];
      if (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.is_admin_reseller
      ) {
        result = [
          { title: this.$t("Home page"), icon: "mdi-home", name: "Home" },
          { title: this.$t("Profile"), icon: "mdi-account", name: "User" },
          {
            title: this.$t("Entities"),
            icon: "mdi-account-box-multiple",
            name: "Resellers Entities",
          },
          {
            title: this.$t("Users"),
            icon: "mdi-account-group",
            name: "Resellers Users",
          },
          {
            title: this.$t("Applications"),
            icon: "mdi-application",
            name: "Applications"
          },
          {
            title: this.$t("Customers"),
            icon: "mdi-account-group-outline",
            name: "Clients",
          },
          {
            title: this.$t("Devices"),
            icon: "mdi-printer-eye",
            name: "Devices",
          },
          { title: this.$t("Licences"), icon: "mdi-license", name: "Licences" },
          {
            title: this.$t("Counters"),
            icon: "mdi-counter",
            name: "Compteurs",
          },
          {
            title: this.$t("Support"),
            icon: "mdi-face-agent",
            name: "Support",
          },
        ];

        if (this.$store.state.auth.user.reseller.customization) {
          result = [
            ...result.slice(0, 2),
            {
              title: this.$t("Customization"),
              icon: "mdi-palette",
              name: "Customization",
            },
            ...result.slice(2),
          ];
        }
      } else {
        result = [
          { title: this.$t("Home page"), icon: "mdi-home", name: "Home" },
          { title: this.$t("Profile"), icon: "mdi-account", name: "User" },
          {
            title: this.$t("Applications"),
            icon: "mdi-application",
            name: "Applications"
          },
          {
            title: this.$t("Customers"),
            icon: "mdi-account-group-outline",
            name: "Clients",
          },
          {
            title: this.$t("Devices"),
            icon: "mdi-printer-eye",
            name: "Devices",
          },
          { title: this.$t("Licences"), icon: "mdi-license", name: "Licences" },
          {
            title: this.$t("Counters"),
            icon: "mdi-counter",
            name: "Compteurs",
          },
          {
            title: this.$t("Support Contact"),
            icon: "mdi-face-agent",
            name: "Support",
          },
        ];
      }
      return result;
    },
    itemsDoc() {
      let items = [];
      if (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.is_admin_reseller
      ) {
        items = [
          {
            id: 1,
            name: this.$t("Documentation"),
            children: [
              { id: 2, name: this.$t("Home page"), route: "DocAccueil" },
              { id: 3, name: this.$t("Profile"), route: "DocProfil" },
              { id: 4, name: this.$t("Entities"), route: "DocEntities" },
              { id: 5, name: this.$t("Users"), route: "DocUsers" },
              { id: 6, name: this.$t("Customers"), route: "DocClients" },
              { id: 7, name: this.$t("Devices"), route: "DocDevices" },
              { id: 8, name: this.$t("Licences"), route: "DocLicences" },
              { id: 9, name: this.$t("Counters"), route: "DocCounters" },
            ],
          },
        ];
      } else {
        items = [
          {
            id: 1,
            name: this.$t("Documentation"),
            children: [
              { id: 2, name: this.$t("Home page"), route: "DocAccueil" },
              { id: 3, name: this.$t("Profile"), route: "DocProfil" },
              { id: 4, name: this.$t("Customers"), route: "DocClients" },
              { id: 5, name: this.$t("Devices"), route: "DocDevices" },
              { id: 6, name: this.$t("Licences"), route: "DocLicences" },
              { id: 7, name: this.$t("Counters"), route: "DocCounters" },
            ],
          },
        ];
      }
      return items;
    },
  },
  mounted() {
    this.snackbar("success", this.$t("Success Login"));
  },
};
</script>
